import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { BASE_MOBILE_API_URL, BASIC_AUTH } from "../constants";
import axios from "axios";
import { notifyError, notifySuccess } from "../components/notify";
import TableLoader from "../components/Spinner/TableLoader";
import { ToastContainer } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import Loader from "../components/Spinner/logoLoader";


const ChangeShop = () => {
      const { setPageTitle } = useOutletContext();
    const navigate = useNavigate();
    const [companyList, setCompanyList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [password, setPassword] = useState("");
    const [showPasswordModal, setShowPasswordModal] = useState(false);

const passRef = useRef();

    const customerStr = localStorage.getItem("customerInfo");
    const customer = customerStr ? JSON.parse(customerStr) : null;

      useEffect(() => {
        setPageTitle("Change Shop");
      }, [setPageTitle]);

    const getCompanyList = useCallback(async () => {
        setLoading(true);

        try {
            const response = await axios.get(
                `${BASE_MOBILE_API_URL}/get_company_list`,
                {
                    params: {
                        mobileno: customer.mobile,
                    },
                    headers: {
                        Authorization: BASIC_AUTH,
                    },
                }
            );

            const result = response.data;
            setCompanyList(result);
        } catch (err) {
            console.error(err);

            if (err.response) {
                // Server responded with error status
                const errorMessage =
                    err.response?.data && typeof err.response.data === "string"
                        ? err.response.data
                        : err.response?.data?.message ||
                        err.response?.data?.error ||
                        "Fatch company list failed";

                notifyError(errorMessage);
            } else if (err.request) {
                // No response received
                notifyError("Server not responding. Please try again.");
            } else {
                // Other errors
                notifyError("Something went wrong.");
            }
        } finally {
            setLoading(false);
        }
    }, [customer]);

    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) return;

        hasFetched.current = true;
        getCompanyList();
    }, [getCompanyList]);


    const handleChangeShop = async () => {
        if (!password) {
            notifyError("Please enter password to change shop.");
            return;
        }
        try {
            const response = await axios.get(`${BASE_MOBILE_API_URL}/customerLogin`, {
                params: {
                    mobileno: customer.mobile,
                    password: password,
                    companycode: selectedCompany.companycode,
                    branchcode: selectedCompany.branchcode,
                },
                headers: {
                    Authorization: BASIC_AUTH,
                },
            });

            const result = response.data;

            sessionStorage.setItem("loginuser", "true");
            localStorage.setItem("loginuser", "true");

            localStorage.setItem("loginusertype", "customer");

            localStorage.setItem("customerInfo", JSON.stringify(response.data));

            notifySuccess(result.RESMSG || "Login successful");
            handleSyncMaster()
           
        } catch (err) {
            if (err.response) {
                const errorMessage =
                    typeof err.response.data === "string"
                        ? err.response.data
                        : err.response.data?.message ||
                        err.response.data?.error ||
                        err.response.data?.RESMSG ||
                        "Login failed";

                notifyError(errorMessage);
            } else if (err.request) {
                notifyError("Server not responding. Please try again.");
            } else {
                notifyError("Something went wrong.");
            }
        };

    };

      const [syncloading, setSyncLoading] = useState(false);



  const handleSyncMaster = useCallback(async () => {
    setSyncLoading(true);


    const apis = [
      {
        url: "/get_item_cat_master",
        key: "itemCategoryMaster",
        params: {
          companycode: customer?.companycode,
          supervisorcode: "0",
          branchcode: customer?.branchcode,
        },
      },
      {
        url: "/get_item_master",
        key: "itemMaster",
        params: {
          companycode: customer?.companycode,
          supervisorcode: "0",
          branchcode: customer?.branchcode,
        },
      },
      {
        url: "/get_branch_item_rate_master",
        key: "branchItemRateMaster",
        params: {
          companycode: customer?.companycode,
          branchcode: customer?.branchcode,
          itemcode: "0",
        },
      },
      {
        url: "/get_customer_item_rate_master",
        key: "customerItemRateMaster",
        params: {
          companycode: customer?.companycode,
        },
      },
      {
        url: "/get_delivery_time_slot",
        key: "deliveryTimeSlot",
        params: {
          companycode: customer?.companycode,
          supervisorcode: "0",
          branchcode: customer?.branchcode,
        },
      },
    ];

    try {
      for (let api of apis) {
        const response = await axios.get(`${BASE_MOBILE_API_URL}${api.url}`, {
          headers: { Authorization: BASIC_AUTH },
          params: api.params, // dynamic params here
        });

        localStorage.setItem(api.key, JSON.stringify(response.data));
      }

      notifySuccess("Master Data Synced Successfully");
       navigate("/dashboard", { replace: true });
    } catch (error) {
      console.error(error);
      notifyError("Sync failed ");
    } finally {
      setSyncLoading(false);
    }
  }, []);

  useEffect(() => {
    if (showPasswordModal) {
      passRef.current?.focus();
    }
  }, [showPasswordModal]);

        return (
            <>
             {syncloading && <Loader message="Syncing Data..." />}
                <div className="container-fluid min-vh-100 bg-black px-0">
                    <div className="company-page">

                        <h5 className="company-title ">Company List</h5>

                        {loading ? (
                            <TableLoader
                                message={`Loading company list...`}
                                size="sm"
                                messageClass="tablemessage-white"
                                spinnerClass="tablespinner-white"
                            />
                        ) : (
                            companyList.map((company, index) => (
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-6 col-lg-4">
                                        <div
                                            key={index}
                                            className="company-card"
                                            onClick={() => {
                                                setSelectedCompany(company);
                                                setShowPasswordModal(true);
                                            }}
                                        >
                                            <div className="company-left">
                                                <img
                                                    src={
                                                        company.company_image
                                                            ? company.company_image
                                                            : "/assest/company-logo.png"
                                                    }
                                                    alt="logo"
                                                />
                                            </div>

                                            <div className="company-right">

                                                <div className="col-12 company-font-size">
                                                    <span className="company-label col-5">
                                                        Company Name :
                                                    </span>
                                                    <span className="company-value">
                                                        {company.company_name}
                                                    </span>
                                                </div>

                                                <div className="col-12 company-font-size">
                                                    <span className="company-label col-5 ">
                                                        Branch Name :
                                                    </span>
                                                    <span className="company-value">
                                                        {company.branchname}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
                <Modal
                    show={showPasswordModal}
                    onHide={() => setShowPasswordModal(false)}
                    
                >
                     <div className="bg-Modal-black">
                    <Modal.Header closeButton>
                        <Modal.Title>Enter Password</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <input
                            type="password"
                            ref={passRef}
                            className="form-control bg-white"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter password "
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={() => setShowPasswordModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="success" onClick={handleChangeShop}>
                            Change Shop
                        </Button>
                    </Modal.Footer>
                    </div>
                </Modal>

                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
            </>
        )
    };

    export default ChangeShop;